import api from "./api";

// All calls automatically carry the logged-in user's token
// via the Authorization interceptor already set up in api.js.

export const listDevices = () => api.get("/devices");

export const registerDevice = (data) => api.post("/devices/register", data);

export const deleteDevice = (serial) => api.delete(`/devices/${serial}`);
